import { optional, array, required, obj } from 'AppReact/schema';
import { extendedItem } from './item';

export default {
  isVisible: required('boolean'),
  charge_code: optional(['integer', 'string']),
  charge_to: required('string'),
  items: array(obj(extendedItem)),
  selectedItemIds: array('integer'),
}

export const defaultPostChargesModal = {
  isVisible: false,
  charge_code: null,
  charge_to: null,
  items: [],
  selectedItemIds: []
}